











import {
  defineComponent, onMounted, useContext,
} from '@nuxtjs/composition-api';
import widgetConfig from '~/modules/catalog/product/composables/useOmnibusPrice/widgetConfig';

export default defineComponent({
  name: 'ProductOmnibusPopup',
  setup() {
    const { env } = useContext();
    const loadScriptOnLoad = () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'omni-chart-js';
      script.src = `${env.VSF_OMNIBUS_WIDGET_URL}/omni-chart.min.js`;

      const link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = `${env.VSF_OMNIBUS_WIDGET_URL}/omni-chart.min.css`;
      document.querySelector('head').append(script);
      document.querySelector('head').append(link);
    };

    onMounted(() => {
      loadScriptOnLoad();
    });

    return {
      widgetConfig,
    };
  },
});
